import styled from "@emotion/styled";
import React from "react";
import Checkbox from "./Checkbox";
import { baseInputCss } from "./Question";
import QuestionWrapper from "./QuestionWrapper";

const StyledQuestionCheckbox = styled.label`
  ${baseInputCss}
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const QuestionCheckbox = (
  props: React.ComponentPropsWithRef<typeof Checkbox> & {
    children: React.ReactNode;
    className?: string;
  },
  ref: React.Ref<HTMLInputElement>
) => {
  const { children, className, ...rest } = props;
  return (
    <QuestionWrapper>
      <StyledQuestionCheckbox className={className}>
        {children}
        <Checkbox {...rest} ref={ref} />
      </StyledQuestionCheckbox>
    </QuestionWrapper>
  );
};

QuestionCheckbox.displayName = "QuestionCheckbox";

export default React.forwardRef(QuestionCheckbox);
